<template>
<div>
    <div class="font-medium flex items-center border-b border-gray-200 dark:border-dark-5 pb-5">
        <ChevronDownIcon class="w-4 h-4 mr-2" /> {{name}}
    </div>
    <div class="mt-5">
        <el-input type="textarea" v-model="value" :rows='5' :disabled='disabled' @change="changeHandle"></el-input>        
    </div>
</div>
</template>
<script>
export default {
    name:'remarkEdit',
    data(){
        return{
            value:'',
        }
    },
    props:{
        name:{
            default:'',
            type:String
        },
        remarkVal:{
            default:'',
            type:String,
        },
        disabled:{
            default:false,
            type:Boolean
        }
    },
    watch:{
        remarkVal:function(newVal,oldVal){
            this.value=newVal;
        }
    },
    methods:{
        changeHandle(){
            this.$emit('update:remarkVal',this.value);
        }
    },
    created(){
        this.value=this.remarkVal;
    }
}
</script>
<style lang="scss" scoped>
.remark-edit{
    h2{
        font-weight: 600;
        font-size: 16px;
      }
}
</style>


